import React from 'react'
import { map, compose, defaultTo } from 'ramda'

export const openGraphMetaTags = compose(map((tag) => {
  return [
    <meta property="og:video:tag" content={tag} />
  ]
}), defaultTo([]))
